import { schema } from 'normalizr';

const CANDIDACIES_SCHEMA = new schema.Entity('candidacies', {}, { idAttribute: '@id' });
const STUDIO_CANDIDACIES_SCHEMA = new schema.Entity('studio_candidacies', {}, { idAttribute: '@id' });

export default {
  Candidacies: CANDIDACIES_SCHEMA,
  StudioCandidacies: STUDIO_CANDIDACIES_SCHEMA
};
